// extracted by mini-css-extract-plugin
export default {"user_profile_style":"user_profile_style_user_profile_style__UYO9J","rsGrey":"user_profile_style_rsGrey__7eUl3"};